function initDownloadActions() {
    let links = document.querySelectorAll('[data-download]');
    let shareLinks = document.querySelectorAll('[data-share]');

    if( links.length ) {
        links.forEach(function(item) {
            item.addEventListener('click', function() {
                let activeElem = document.querySelector('[data-downloadLinks].active, [data-shareLinks].active');
                let linksWrapper = document.querySelector('[data-downloadLinks="' + this.getAttribute('data-download') +'"]');

                if (!linksWrapper.classList.contains('active') ) {
                    linksWrapper.classList.add('active');
                }
                if ( activeElem ) {
                    activeElem.classList.remove('active');
                }
            });
        });
    }

    if (shareLinks.length ) {
        shareLinks.forEach(function(item) {
            item.addEventListener('click', function() {
                let activeElem = document.querySelector('[data-downloadLinks].active, [data-shareLinks].active');
                let linksWrapper = document.querySelector('[data-shareLinks="' + this.getAttribute('data-share') +'"]');

                if (!linksWrapper.classList.contains('active') ) {
                    linksWrapper.classList.add('active');
                }
                if ( activeElem ) {
                    activeElem.classList.remove('active');
                }
            });
        });
    }
}



// window.addEventListener('load', function () {
//     initDownloadActions();
// });


export { initDownloadActions }


//////////////////
// WEBPACK FOOTER
// ./js/modules/download.js
// module id = 2
// module chunks = 0